import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
// import { MatomoTracker } from 'ngx-matomo-client';
import { takeUntil } from "rxjs";
import { map, switchMap, tap } from "rxjs/operators";

import { AbstractInFunnelComponent } from "../../shared/components/funnel/abstract.in-funnel.component";
import { FunnelService } from "../../shared/services/funnel.service";
import { Role } from "../../users/models/users.entity";
import { ProfileService } from "../../users/services/profile.service";
import { mediumCategoryColors, mediumPillarColors, PillarSlug } from "../colors";
import { ThematicCategorySlug } from "../models/category.model";
import { Thematic } from "../models/thematic.model";
import { ThematicRepository } from "../repositories/thematic.repository";

@Component({
  selector: 'app-thematic-details',
  templateUrl: './thematic-details.component.html',
  styleUrls: [ './thematic-details.component.scss' ]
})
export class ThematicDetailsComponent extends AbstractInFunnelComponent {
  thematic!: Thematic;

  workingOnBulletPoints: string[] = [];

  override isFunnelFirstStep = true;

  categorySlug?: ThematicCategorySlug;

  colorMedium!: string;

  relatedThematics: Thematic[] = [];

  isTalker = false;

  changingThematic = false;

  loaded = false;

  @ViewChild('page') elementRef!: ElementRef<HTMLElement>;

  // private readonly tracker = inject(MatomoTracker);

  constructor(protected override readonly route: ActivatedRoute,
              protected override readonly funnelService: FunnelService,
              private readonly profileService: ProfileService,
              private readonly router: Router,
              private readonly thematicRepository: ThematicRepository,
              ) {
    super(funnelService, route);
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();

    this.funnelService.componentLoading$.next(!this.loaded);
  }

  override ngOnInit() {
    this.funnelService.resetScroll$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.elementRef.nativeElement.scrollTo({ top: 0, behavior: "auto" });
      });
    this.isTalker = this.profileService?.profile?.role === Role.Talker;
    this.route.data
      .pipe(
        map(data => data.thematic),
        tap((thematic: Thematic) => {
          this.thematic = thematic;
        }),
        // Fetch all available thematics to find related ones by pillar
        switchMap(() => this.thematicRepository.getAvailableOnes())
      ).subscribe((allThematics: Thematic[]) => {
      this.previousMessage = 'Retour aux thématiques';
      super.ngOnInit();

      // Use pillar colors if available, otherwise fallback to category colors
      const pillarName = this.thematic.pillar?.name as PillarSlug;
      this.categorySlug = this.thematic.category?.slug;
      this.colorMedium = pillarName
        ? mediumPillarColors[pillarName]
        : (this.categorySlug ? mediumCategoryColors[this.categorySlug] : '');

      this.workingOnBulletPoints = this.thematic.workingOn?.split('\n') ?? [];

      // Get related thematics by pillar (same pillar, different thematic, not archived)
      if (this.thematic.pillar?.name) {
        this.relatedThematics = allThematics.filter(t =>
          t.id !== this.thematic.id &&
          t.pillar?.name === this.thematic.pillar?.name &&
          !t.isArchived &&
          t.isEnabled
        );
      } else if (this.thematic.category?.thematics) {
        // Fallback to category-based related thematics for backward compatibility
        this.relatedThematics = this.thematic.category.thematics.filter(t =>
          t.id !== this.thematic.id
        );
      } else {
        this.relatedThematics = [];
      }

      this.loaded = true;
      this.funnelService.componentLoading$.next(!this.loaded);
    });
  }

  editThematic() {
    this.router.navigate([ 'thematics', this.thematic.slug, "edit" ]);
  }


  goToThematic(slug: string) {
    this.changingThematic = true;
    // this.tracker.trackEvent(TrackerCategory.TRAINS_TALKER, TrackerAction.CLICK, 'discoverThematicButton');
    this.router.navigate([ 'thematics', slug ]);
  }
}
